/** @jsx jsx */
import React from "react"
import { jsx } from "theme-ui"
import { Helmet } from "react-helmet"

import CookiesSE from "@components/Cookies/CookiesSE"
import CookiesFI from "@components/Cookies/CookiesFI"
const { GATSBY_LOCALE } = process.env

export default function CookiesPage() {
  const cookieLocationMapper = {
    SE: <CookiesSE />,
    FI: <CookiesFI />,
  }

  return (
    <>
      <Helmet>
        <title>Cookies - Brocc</title>
      </Helmet>
      {cookieLocationMapper[GATSBY_LOCALE] ? (
        cookieLocationMapper[GATSBY_LOCALE]
      ) : (
        <CookiesSE />
      )}
    </>
  )
}
